export enum IdentificationDocumentType {
  Id = 'I',
  Passport = 'P',
  Asylum = 'A',
}

export interface PersonalInfo {
  firstName: string;
  lastName: string;
  dateOfBirth?: string;
}

export interface Mobile {
  number?: string;
  otp?: string;
}
